import React from 'react';
import { SubscribeBlogForm } from './SubscribeBlogForm';
import { SubscriptionBoxStyles as classes } from './styleObjects/SubscriptionBoxStyles';
import { useTranslation } from '@stateManagement/TranslationContext';
import { getTranslation } from '@helpers/languageTranslations';
import { Heading } from '@web-for-marketing/react-ui';

export interface BlogSubscriptionBoxProps {
    type?: 'full' | 'short';
}

export function BlogSubscriptionBox({ type = 'full' }: BlogSubscriptionBoxProps): React.ReactElement {
    const { selectedLanguageTranslation } = useTranslation();
    const geotabSubscribeTranslation = getTranslation(
        selectedLanguageTranslation,
        'authorBiography',
        'geotabSubscribe'
    );
    const isShort = type === 'short';

    return (
        <div css={isShort ? classes.shortBoxContainer : classes.boxContainer} data-testid='blog-subscribe-box'>
            <Heading variant={isShort ? 'h3' : 'h2'} weight='bold' component='h2' css={classes.title}>
                {geotabSubscribeTranslation.subscribeTo}
            </Heading>
            <SubscribeBlogForm />
        </div>
    );
}
